export default (($) => {
    console.log('UNTUCKit : Module : CustomCheckbox : loaded');
    const $dom = {};
    const cacheDOM = () => {
        $dom.checkboxPlaceholders = $('.js-checkbox-placeholder');
    };
    const bindUIActions = () => {
        $dom.checkboxPlaceholders.parent().on("click", function (e) {
            // prevent label click from activating checkbox
            e.preventDefault();
        });
        $dom.checkboxPlaceholders.on('click keydown', function (e) {
            if (e.type === "keydown" && (e.code !== 'Enter' || e.keyCode !== 13)) {
                return;
            }
            const realCheckboxId = $(this).data('checkbox');
            const $realCheckbox = $('#' + realCheckboxId);
            $realCheckbox.prop('checked', !$realCheckbox.prop('checked'));
            $(this).toggleClass('checkbox-placeholder--checked');
        });
    };
    const init = () => {
        console.log('UNTUCKit : Module : CustomCheckbox : init');
        cacheDOM();
        bindUIActions();
    };
    return { init };
})($);
